import { useQuery } from "react-query";
import { fetcher } from "@weezevent/weezjs-core";
import { useTranslation } from "react-i18next";
import { getUnifiedLocale } from "../../utils/formatters";

const getWeezTags = params => {
	return fetcher.get(`/weeztags/`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});
};

const useWeezTags = ({ params = null, options = {} } = {}) => {
	const { i18n } = useTranslation();
	const locale = getUnifiedLocale(i18n.accountLocale);

	const queryParams = { ...params, locale };
	return useQuery(
		["weez-tags", queryParams],
		() => getWeezTags(queryParams),
		{
			...options,
			enabled: options?.enabled ?? true,
			select: res => res.response
		}
	);
};

export default useWeezTags;
